import React, { useState, useEffect } from 'react';
import { getLocalStorageUsage, cleanupLocalStorage } from '../utils/storageUtils';

const StorageMonitor = () => {
  const [usage, setUsage] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const refreshUsage = () => {
    const currentUsage = getLocalStorageUsage();
    setUsage(currentUsage);
  };

  useEffect(() => {
    refreshUsage();
  }, []);

  const handleCleanup = () => {
    const result = cleanupLocalStorage();
    refreshUsage();
    
    alert(`🧹 Dọn dẹp hoàn tất!\n\n` +
          `Đã xóa ${result.removedItems.length} mục\n` +
          `Tiết kiệm: ${result.spaceSaved.toFixed(2)} MB\n` +
          `Dung lượng mới: ${result.newUsage} MB`);
  };

  if (!usage) return null;

  const usagePercentage = (usage.totalSize / (5 * 1024 * 1024)) * 100;
  const isNearLimit = usagePercentage > 80;

  return (
    <div className={`bg-white rounded-xl shadow-lg p-4 border-l-4 ${
      isNearLimit ? 'border-red-500' : 'border-green-500'
    }`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className={`text-2xl ${isNearLimit ? 'text-red-500' : 'text-green-500'}`}>
            {isNearLimit ? '⚠️' : '💾'}
          </div>
          <div>
            <h3 className="font-semibold text-gray-800">Bộ nhớ trình duyệt</h3>
            <p className="text-sm text-gray-600">
              {usage.totalSizeInMB} MB / 5 MB ({usagePercentage.toFixed(1)}%)
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <button
            onClick={refreshUsage}
            className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors"
          >
            🔄 Làm mới
          </button>
          
          {isNearLimit && (
            <button
              onClick={handleCleanup}
              className="px-3 py-1 text-sm bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
            >
              🧹 Dọn dẹp
            </button>
          )}
          
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
          >
            {isExpanded ? '▲' : '▼'} Chi tiết
          </button>
        </div>
      </div>

      {/* Progress bar */}
      <div className="mt-3">
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all duration-300 ${
              isNearLimit ? 'bg-red-500' : 'bg-green-500'
            }`}
            style={{ width: `${Math.min(usagePercentage, 100)}%` }}
          ></div>
        </div>
      </div>

      {/* Detailed breakdown */}
      {isExpanded && (
        <div className="mt-4 border-t pt-4">
          <h4 className="font-medium text-gray-800 mb-3">Chi tiết sử dụng:</h4>
          <div className="space-y-2 max-h-60 overflow-y-auto">
            {Object.entries(usage.items)
              .sort(([,a], [,b]) => b.size - a.size)
              .map(([key, info]) => (
                <div key={key} className="flex justify-between items-center py-1 px-2 bg-gray-50 rounded">
                  <span className="text-sm font-mono text-gray-700 truncate flex-1 mr-2">
                    {key}
                  </span>
                  <span className="text-sm text-gray-600 whitespace-nowrap">
                    {info.sizeInMB} MB
                  </span>
                </div>
              ))}
          </div>
          
          <div className="mt-3 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>💡 Mẹo:</strong> Nếu bộ nhớ gần đầy, hãy tối ưu hình ảnh trong nội dung tùy chỉnh 
              hoặc sử dụng nút "Dọn dẹp" để xóa dữ liệu không cần thiết.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default StorageMonitor;
